export * from './delete-abteilung.service';
export * from './delete-abteilung.service.module';